export function isActiveFilter(filter) {
  const EMPTY_STRING = '';
  const ZERO = 0;

  return (
    (filter.filter_by && filter.filter_by !== EMPTY_STRING) ||
    filter.filter_by === ZERO
  );
}
